// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "style/" + chunkId + "." + {"2":"7f05950238efea93ac56","481":"2c78da456df582d15921","815":"d7304447649c4dfbb7b8"}[chunkId] + ".css";
};